import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Models } from '@ibexfusion/models';
import { PrivilegeService } from '@services/privileges/privilege.service';
import { DataTableEvent } from '../../../../components/data-table/data-table.component';

@Component({
    selector: 'app-profile-role-selection',
    templateUrl: './role-privilege-selection.component.html',
    styleUrls: ['./role-privilege-selection.component.scss'],
    providers: [PrivilegeService],
    standalone: false
})
export class RolePrivilegeSelectionComponent implements OnInit {

  @ViewChild('hStepper') stepper: MatStepper;

  firstFormGroup: UntypedFormGroup;
  secondFormGroupEdit: UntypedFormGroup;

  selectedPrivilegeId: string;
  boundPrivilege: Models.Privilege;
  roleHasPrivilegeValue: string;
  values = [];

  edit = false;

  constructor(
    public dialogRef: MatDialogRef<RolePrivilegeSelectionComponent>,
    public privilegeService: PrivilegeService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.edit = this.data && this.data.edit;
    if (this.edit) {
      this.selectedPrivilegeId = this.data.roleHasPrivilege.PrivilegeID;
      this.roleHasPrivilegeValue = this.data.roleHasPrivilege.value;
      this.privilegeService.get(this.data.roleHasPrivilege.PrivilegeID).then(privilege => {
        this.boundPrivilege = privilege;
      });
    } else {
      this.values.push('');
    }
    this.firstFormGroup = this.formBuilder.group({
      privilegeId: ['', Validators.required]
    });
    this.secondFormGroupEdit = this.formBuilder.group({
      roleHasPrivilegeValue: ['', Validators.required]
    });
  }

  selectPrivilege(event: DataTableEvent) {
    this.selectedPrivilegeId = event.row.PrivilegeID;
    this.privilegeService.get(this.selectedPrivilegeId).then(privilege => {
      this.boundPrivilege = privilege;
      this.stepper.next();
    });
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      PrivilegeID: this.selectedPrivilegeId,
      value: this.roleHasPrivilegeValue,
      values: this.values
    });
  }

  update() {
    this.dialogRef.close({
      PrivilegeID: this.selectedPrivilegeId,
      value: this.roleHasPrivilegeValue,
      id: this.data.roleHasPrivilege.ID
    });
  }

  addValue() {
    this.values.push('');
  }

  trackByFn(index: any, item: any) {
    return index;
  }

}
